// extracted by mini-css-extract-plugin
export default {"unlockIcon":"VariantLock_unlockIcon__SPWka","lockIcon":"VariantLock_lockIcon__Kx0Lf","disabled":"VariantLock_disabled__mibtH"};